/* NEW: UI_REVAMP */
import { Box, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { CopyIcon } from '@chakra-ui/icons';

const MESSAGE_DURATION_MS = 1600;

const copyText = async (value) => {
	const text = String(value ?? '');

	if (!text) return false;

	if (navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(text);
		return true;
	}

	const textArea = document.createElement('textarea');
	textArea.value = text;
	textArea.setAttribute('readonly', '');
	textArea.style.position = 'fixed';
	textArea.style.top = '-9999px';
	textArea.style.opacity = '0';
	document.body.appendChild(textArea);
	textArea.select();
	const isCopied = document.execCommand('copy');
	document.body.removeChild(textArea);

	return isCopied;
};

const CopyValueButton = ({
	value,
	successMessage = 'Copied successfully',
	errorMessage = 'Copy failed',
	ariaLabel = 'Copy value',
	color = '#111111',
}) => {
	const [message, setMessage] = useState('');

	useEffect(() => {
		if (!message) return undefined;

		const timer = window.setTimeout(() => {
			setMessage('');
		}, MESSAGE_DURATION_MS);

		return () => window.clearTimeout(timer);
	}, [message]);

	const handleCopy = async (event) => {
		event.preventDefault();
		event.stopPropagation();

		try {
			const isCopied = await copyText(value);
			setMessage(isCopied ? successMessage : errorMessage);
		} catch {
			setMessage(errorMessage);
		}
	};

	return (
		<>
			<Box
				as='button'
				type='button'
				aria-label={ariaLabel}
				display='flex'
				alignItems='center'
				justifyContent='center'
				width='16px'
				height='16px'
				color={color}
				cursor='pointer'
				onClick={handleCopy}
			>
				<CopyIcon boxSize='16px' color={color} />
			</Box>

			{message ? (
				<Box
					position='fixed'
					top='50%'
					left='50%'
					transform='translate(-50%, -50%)'
					minWidth='180px'
					maxWidth='90vw'
					borderRadius='12px'
					padding='2px'
					background='linear-gradient(180deg, #F5D7A9 0%, #E28E10 10.42%, #E3CA89 25%, #E2A74C 69.79%, #4D3A1A 85.42%, #F5D7A9 100%)'
					boxShadow='0 8px 24px rgba(0, 0, 0, 0.24)'
					pointerEvents='none'
				>
					<Flex
						alignItems='center'
						justifyContent='center'
						width='100%'
						padding='12px 20px'
						borderRadius='10px'
						background='linear-gradient(180deg, #EBEAFF 0%, #C5C3FE 25%, #C5C3FE 75%, #EBEAFF 100%)'
					>
						<Text
							color='rgba(76, 49, 253, 1)'
							fontSize='16px'
							fontWeight='600'
							lineHeight='100%'
							textAlign='center'
						>
							{message}
						</Text>
					</Flex>
				</Box>
			) : null}
		</>
	);
};

export default CopyValueButton;
